import Vue from 'vue';
import toast from './toast.vue';

// export default{
//     install(Vue,options){
//         Vue.mixin({
//             methods: {
//                 //添加辅助函数
//             }
//         })
//         Vue.prototype.$showToast = (text, duration = 2000)=>{
//             let ToastConstructor = Vue.extend(toast); //创建一个扩展实例构造器
//             const toastDom = new ToastConstructor({  // 实例化 toast.vue
//                 el: document.createElement('div'),
//                 data() {
//                     return {
//                         toastShow:true,
//                         toastText:text,
//                     }
//                 }
//             })
//             document.body.appendChild(toastDom.$el);             // 添加到body里
//             setTimeout(() => {toastDom.toastShow = false} ,duration); // 隐藏
//         }
//     }
// }

const install = () => {
    let ToastConstructor = Vue.extend(toast); //创建一个扩展实例构造器
    Object.defineProperty(Vue.prototype, '$showToast', {
        get (){
            // 实例化一个 toast.vue
            return (text, duration = 2000)=>{
                const toastDom = new ToastConstructor({
                    el: document.createElement('div'),
                    data() {
                        return {
                            toastText:text,
                            toastShow:true
                        }
                    }
                })
                // 把 实例化的 toast.vue 添加到 body 里
                document.body.appendChild(toastDom.$el)
                // 过了 duration 时间后隐藏
                setTimeout(() => {toastDom.toastShow = false} ,duration);
            }
        }
    })
}

export default install;

// const showToast = {
//     // install 是默认的方法。当外界在 use 这个组件的时候，就会调用本身的 install 方法，同时传一个 Vue 这个类的参数。
//     install:function(Vue){
//         Vue.component('showToast',toast)
//     }
// }
// // 导出
// export default showToast;


// WEBPACK FOOTER //
// ./src/components/toast/index.js